import React, { useState, useEffect, useRef, useCallback } from "react"

import SwiperCore, {
  Navigation,
  Thumbs,
  Keyboard,
  Mousewheel,
  A11y,
  Scrollbar,
  FreeMode,
} from "swiper"

import { Swiper, SwiperSlide } from "swiper/react"

import PropTypes from "prop-types"
import useWindowResize from "@/hooks/useWindowResize"

import VideoWrapper from "@/components/VideoWrapper/VideoWrapper"

import Image from "@/components/Shared/Image"

import { appendPresetToUrl, getPresetThumbnailUrl } from "@/utils/helper"
import { PDP_SLIDER_SIZES } from "@/constants/index"

import missingImage from "@/public/images/image-missing.png"
import zoomVideoIcon from "@/styles/images/zoom-video-icon.svg"
import pdpVideoPlayIcon from "@/styles/images/play-button-overlay.svg"
import tapImageZoom from "@/styles/images/tap-image-zoom.svg"
import threeSixtyIcon from "@/styles/images/360-spin-overlay.svg"

import {
  closeZoomImage,
  initZoomviewer,
  openModal,
  openModalAction,
  zoomVideoImage,
  spin360Open,
  spin360PdpGallery,
  pauseAllVideo,
} from "@/components/ImageGallery/v3/utlis"
import {
  addAnalyticsClickCloseZoom,
  addAnalyticsClickPdpImageVideo,
  addAnalyticsClickSliderImageVideo,
  addAnalyticsClickZoomImage,
  addAnalyticsClickZoomReset,
  addAnalyticsClickZoomSpinnerAndFullscreen,
  addAnalyticsPdpSlider,
  addAnalyticsPdpSliderFilmStrip,
  addAnalyticsZoomImageSliderArrow,
  addPdpThumbnailAnylticsClick,
} from "@/components/ImageGallery/v3/analytics"

import "swiper/swiper.css"
import ImageHeroSection from "@/components/ImageGallery/v3/ImageHeroSection"

const ImageReel = props => {
  const {
    data = [],
    isModel = false,
    swatchUrl = "",
    productInfo = [],
    isHorizontal = false,
    galleryStackId = "",
    assetAccountName = "",
    imageClickCounter = 1,
    presetConfigObject = {},
    productGalleryLabel = {},
    initialImgAlt = "",
    initialImgUrl = "",
    pdpDesktopImage = "",
    productImagesWithUrls = {},
    threeSixtyResourceData = {},
    clickedProductVariant = false,
    layerImageData = {},
  } = props || {}

  SwiperCore.use([Thumbs, Keyboard, Mousewheel, A11y, Scrollbar, FreeMode])

  const swiperThumbRef = useRef(null)
  const swiperPdpRef = useRef(null)
  const iframeContainer = useRef(null)
  const threeSixtyIframeContainer = useRef(null)

  const pdpType = productInfo?.[0]?.pdpType || ""

  const {
    resourceFullWebUrl = "",
    resourceName = "",
    resourceTypeImg = "",
    resourceAltText = "",
  } = threeSixtyResourceData

  const [width] = useWindowResize({ debounceMs: 150 })
  const viewportWidth =
    width || (typeof window !== "undefined" ? window.innerWidth : 0)
  const presetWidth = viewportWidth || 1024

  const [activeImage, setactiveImage] = useState(null)
  const [zoomVideoId, setZoomVideoId] = useState(null)
  const [currentVideoId, setCurrentVideoId] = useState(null)
  const [zoomEntryPoint, setZoomEntryPoint] = useState(null)
  const [thumbnailClicked, setThumbnailClicked] = useState(false)
  const [threeSixtyZoomClick, setThreeSixtyZoomClick] = useState(false)

  const [currentSlide, setCurrentSlide] = useState(0)
  const [isThreeSixtyRender, setIsThreeSixtyRender] = useState(false)

  const [activeIndex, setActiveIndex] = useState(0)

  const [thumbsSwiper, setThumbsSwiper] = useState(null)

  const slickRef = useRef(null)

  const totalImages = isHorizontal ? data.length : 3
  const { largeIpadSize, imageReelTitle, mobileSize } = PDP_SLIDER_SIZES

  const resourceCredits =
    productGalleryLabel &&
    productGalleryLabel.resourceCredit_s &&
    productGalleryLabel.resourceCredit_s.match("http") == null
      ? productGalleryLabel.resourceCredit_s
      : ""

  const imageSequence = imageClickCounter ? imageClickCounter + 1 : null
  const getThumbnailSrc = assetId =>
    swatchUrl &&
    assetId &&
    presetConfigObject?.LandscapeCategory &&
    presetConfigObject?.Thumbnail
      ? getPresetThumbnailUrl(
          assetAccountName,
          swatchUrl,
          assetId,
          presetConfigObject
        )
      : appendPresetToUrl(
          assetAccountName,
          swatchUrl,
          assetId,
          viewportWidth,
          presetConfigObject,
          true
        )
  const getMainImageSrc = assetId =>
    appendPresetToUrl(
      assetAccountName,
      swatchUrl,
      assetId,
      presetWidth,
      presetConfigObject,
      true
    )

  const pdpImages = data?.reduce((acc, ini) => {
    if (
      acc.filter(item => item.assetId === ini.assetId).length === 0 ||
      ini.type === "video"
    ) {
      acc.push(ini)
    }
    return acc
  }, [])

  const allPdpImages = [
    ...pdpImages.filter(item => !item.type),
    threeSixtyResourceData,
    ...pdpImages.filter(item => item.type === "video"),
  ]

  if (layerImageData?.layerUrl !== "") {
    if (!layerImageData?.layerUrl.includes("<<IMAGE")) {
      allPdpImages.unshift({
        ...layerImageData,
        assetId: layerImageData?.layerUrl.split("/image/PAWEB/")[1],
      })
    }
  }
  useEffect(() => {
    swiperThumbRef.current?.swiper.slideTo(0)
    swiperPdpRef.current?.swiper.slideTo(0)
  }, [layerImageData?.layerUrl])

  const pdpCustomImagesArray = allPdpImages.filter(
    value => Object.keys(value).length !== 0
  )

  const pdpImageArrayLength = pdpCustomImagesArray?.length

  let fullScreenTimer

  const ZoomValue = useRef(0)
  const ZoomValuePDP = useRef(0)

  const zoomSpinCBPdp = eventInfo => {
    const [eventType, eventValue] = eventInfo.split(",")
    if (eventType === "SPIN" && eventValue > 0) {
      zoom360SpinnerClickAction()
    } else if (
      eventType === "ZOOM" &&
      (eventValue !== 0 || eventValue !== 100)
    ) {
      if (Number(ZoomValuePDP.current) > Number(eventValue)) {
        zoomOut360ButtonClickAction({ is360Image: true, isImageGallery: true })
      } else {
        zoomInButton360ClickAction({
          is360Image: true,
          isImageGallery: true,
        })
      }
      ZoomValuePDP.current = eventValue
      ZoomValue.current = 0
    }
  }

  const zoomSpinCB = eventInfo => {
    const [eventType, eventValue] = eventInfo.split(",")
    if (eventType === "SPIN" && eventValue > 0) {
      zoom360CarasoulSpinnerClickAction()
    } else if (
      eventType === "ZOOM" &&
      (eventValue !== 0 || eventValue !== 100)
    ) {
      if (Number(ZoomValue.current) > Number(eventValue)) {
        zoomOut360ButtonClickAction({ is360Image: false, isImageGallery: true })
      } else {
        zoomInButton360ClickAction({
          is360Image: false,
          isImageGallery: true,
        })
      }
      ZoomValue.current = eventValue
      ZoomValuePDP.current = 0
    }
  }

  const threeSixtyOpen = (assetId = "", imageLable = "", i = "") => {
    if (assetId) {
      setactiveImage("")
      setactiveImage(assetId)
      setThreeSixtyZoomClick(true)
      const s7viewerZoom = document.querySelector("#s7viewer")
      if (s7viewerZoom) {
        document.getElementById("s7viewer").innerHTML = ""
      }
      document.getElementById("s7viewer").style.display = "none"
      document.getElementById("s7viewerSpinThreeSixty").style.display = "block"
      const element = document.querySelector(".product-details")
      element?.classList.add("three-sixty-image-gallery")
      spin360Open(assetId, zoomSpinCB)
      addAnalyticsClickSliderImageVideo({
        index: i + 1,
        imageVideoId: assetId,
        totalImages: pdpImageArrayLength,
        pdpType,
        zoomEntryPoint: zoomEntryPoint,
        imageLable,
        imageClick: true,
        resourceType: resourceTypeImg.length
          ? resourceTypeImg?.[0].toLowerCase()
          : "n/a",
        isThreeSixtyImage: true,
        productInfo,
      })
    }
  }

  const isOnePdpImage = initialImgUrl && pdpDesktopImage ? initialImgUrl : ""
  const firstImageForZoom =
    data && pdpImages?.length ? pdpImages[0].assetId : isOnePdpImage

  const beforeChangeHandler = (swiper = {}) => {
    const elementThumbSlider = document.querySelector(
      ".pdp-thumbnail-vertical .swiper-slide"
    )
    if (elementThumbSlider) {
      elementThumbSlider?.classList.remove("imageActiveThumb")
    }
    const current = swiper?.previousIndex
    const next = swiper?.realIndex
    setCurrentSlide(next)
    setActiveIndex(next)
    const imagesLength = allPdpImages.filter(item => !item.type).length
    const checkIs360Spin =
      resourceName?.[0] && resourceFullWebUrl?.[0] && next === imagesLength

    if (next === imagesLength) {
      if (resourceName?.[0] && resourceFullWebUrl?.[0]) {
        document.getElementById("s7viewerGallery").innerHTML = ""
        spin360PdpGallery(resourceName?.[0], zoomSpinCBPdp)
      }
    }
    if (
      viewportWidth <= largeIpadSize &&
      resourceName?.[0] &&
      resourceFullWebUrl?.[0]
    ) {
      document.body.classList.remove("full-screen-open")
      document.body.style.overflow = ""
    }
    pauseAllVideo()
    const elementSlider = document.querySelector(".pdp-thumbnail-vertical")
    elementSlider?.classList.add("pdp-slide-change")
    const arrowLabel = current > next ? "left" : "right"
    const pdpImageInfo = allPdpImages
      ?.map((item, index) => ({ ...item, index }))
      .find(item => item?.index === next)
    if (thumbnailClicked) {
      setThumbnailClicked(false)
    } else {
      addAnalyticsPdpSlider({
        pdpImageInfo,
        totalImages: pdpImageArrayLength,
        pdpType,
        arrowLabel,
        resourceType: checkImageResoruceType(pdpImageInfo?.assetId) || "",
        checkIs360Spin,
        productInfo,
      })
    }
  }

  const beforeChangeHandlerFilmStrip = (swiper = {}) => {
    const current = swiper?.previousIndex
    const next = swiper?.realIndex
    if (viewportWidth < largeIpadSize) {
      const arrowLabel = current > next ? "left" : "right"
      const pdpImageInfo = allPdpImages
        ?.map((item, index) => ({ ...item, index }))
        .find(item => item?.index === next)

      addAnalyticsPdpSliderFilmStrip({
        pdpImageInfo,
        totalImages: pdpImageArrayLength,
        pdpType,
        arrowLabel,
        resourceType: checkImageResoruceType(pdpImageInfo?.assetId) || "",
        productInfo,
      })
    }
  }

  const handleOpenModal = () => {
    openModal(window.s7viewers)
    window.addEventListener("keydown", handleKey)
  }

  useEffect(() => {
    handleOpenModal()

    if (resourceFullWebUrl?.[0] && resourceName?.[0]) {
      spin360PdpGallery(resourceName?.[0], zoomSpinCBPdp)
    }
  }, [])

  useEffect(() => {
    if (
      swiperThumbRef?.current &&
      clickedProductVariant &&
      swiperPdpRef?.current &&
      data?.length
    ) {
      swiperThumbRef.current?.swiper.slideTo(0)
      swiperPdpRef.current?.swiper.slideTo(0)
      setActiveIndex(0)
    }
  }, [clickedProductVariant])

  let isZoomClick = false
  const slickGotoSlider = sliderNumber => {
    slickRef.current.slickGoTo(sliderNumber)
  }

  const openImageZoom = (
    image = "",
    i = 0,
    currentImageName = "",
    element = {},
    layerImageResourse
  ) => {
    if (element?.resourceFullWebUrl?.[0] && element?.resourceName?.[0]) {
      spin360Open(element?.resourceName?.[0], zoomSpinCB)
      setactiveImage("")
      setactiveImage(element?.resourceName?.[0])
    } else {
      const resourceType = checkImageResoruceType(image)
      setZoomEntryPoint("image gallery")
      setZoomVideoId("")
      setactiveImage("")
      setactiveImage(image || layerImageResourse)
      openModalAction({ image: image, layeredImage: layerImageResourse })

      if (viewportWidth < mobileSize) {
        slickGotoSlider(i)
      }
      addAnalyticsClickPdpImageVideo({
        index: i + 1,
        mediaType: imageReelTitle,
        imageVideoName: currentImageName || "n/a",
        totalImages: pdpImageArrayLength,
        pdpType,
        assetId: image || layerImageResourse.split("/image/PAWEB/")[1],
        resourceType: resourceType?.toLowerCase(),
        productInfo,
      })
    }
  }

  const viewGalleryImageClick = useCallback((imageAssetID = "") => {
    setZoomEntryPoint("image gallery")
    setactiveImage(imageAssetID)
    if (imageAssetID.includes("/image/PAWEB/")) {
      openModalAction({ layeredImage: imageAssetID })
    } else {
      openModalAction({ image: imageAssetID })
    }
  })

  const imageZoomClick = (image = "", i = 0, imageName = "", element = {}) => {
    setThreeSixtyZoomClick(false)
    document.getElementById("s7viewerSpinThreeSixty").style.display = "none"
    document.getElementById("s7viewer").style.display = "block"
    if (image) {
      let layeredImageassetID = ""
      const resourceType = checkImageResoruceType(image)
      setZoomVideoId("")
      setactiveImage("")
      if (image.includes("/image/PAWEB/")) {
        layeredImageassetID = image.split("/image/PAWEB/")[1]
        initZoomviewer(layeredImageassetID)
      } else {
        initZoomviewer(image)
      }

      setactiveImage(image)

      addAnalyticsClickSliderImageVideo({
        index: i + 1,
        imageVideoId: layeredImageassetID || image,
        totalImages: pdpImageArrayLength,
        pdpType,
        zoomEntryPoint: zoomEntryPoint,
        imageName,
        imageClick: true,
        resourceType: resourceType?.toLowerCase(),
        isThreeSixtyImage: false,
        productInfo,
      })
      setTabIndexGallery()
    }
  }

  const imageZoomVideoClick = (video = "", i = 0) => {
    setZoomVideoId(video)
    setactiveImage("")
    setActiveIndex(i)
    if (viewportWidth < 1023) {
      setZoomEntryPoint(imageReelTitle)
    }
    setactiveImage(video)
    setCurrentVideoId(i + 1)
    zoomVideoImage()
    setTabIndexGallery()
  }

  const getVideoInfo = (targetElement = "", index = "", videoId = "") => {
    addAnalyticsClickSliderImageVideo({
      index,
      imageVideoId: videoId,
      totalImages: pdpImageArrayLength,
      pdpType,
      zoomEntryPoint: zoomEntryPoint,
      imageName: targetElement?.videoTitle,
      imageClick: false,
      isThreeSixtyImage: false,
      productInfo,
    })
  }

  const imageZoomMobileVideoClick = (video = "", i = 0) => {
    if (viewportWidth < 1023) {
      setZoomEntryPoint(imageReelTitle)
    }
    setactiveImage("")

    setCurrentVideoId(i + 1)
    setZoomVideoId(video)
    if (viewportWidth < mobileSize) {
      slickGotoSlider(i)
    }
    openModalAction({ image: video, isVideo: true })
    setactiveImage(video)
  }

  const closeZoomImageClick = useCallback(() => {
    const checkIsThreeSixty = document.querySelector(
      ".three-sixty-image-gallery"
    )

    counter = 0
    zoomOutCounter = 0
    setZoomVideoId(false)
    closeZoomImage()
    let currentImageData = {}
    let resourceType = null
    if (checkIsThreeSixty) {
      currentImageData = {
        assetId: resourceName?.[0],
        label: resourceAltText?.[0],
        index: 1,
      }
      resourceType = resourceTypeImg?.[0].length
        ? resourceTypeImg?.[0].toLowerCase()
        : null
    } else {
      currentImageData = pdpCustomImagesArray
        ?.map((item, index) => ({ ...item, index }))
        .find(
          item => item?.assetId === activeImage || item?.url === activeImage
        )
      resourceType = checkImageResoruceType(currentImageData?.assetId) || null
    }

    addAnalyticsClickCloseZoom({
      pdpType,
      zoomEntryPoint,
      currentImageData,
      totalImages: pdpImageArrayLength,
      productInfo,
      resourceType,
      isThreeSixty: checkIsThreeSixty,
    })
  })

  const currentImageData = allPdpImages
    ?.map((item, index) => ({ ...item, index }))
    .find(item => item?.assetId === activeImage || item?.url === activeImage)

  useEffect(() => {
    let zoomImageClick = null
    let zoomGallaryAddEventListner
    if (
      iframeContainer?.current &&
      activeImage &&
      zoomEntryPoint &&
      !zoomGallaryAddEventListner
    ) {
      zoomGallaryAddEventListner = setTimeout(() => {
        const zoomInButtonClick = iframeContainer?.current.querySelector(
          ".s7button.s7zoominbutton"
        )
        if (zoomInButtonClick) {
          setTabIndexGallery()
          zoomInButtonClick.addEventListener(
            "click",
            e => {
              const threeSixtyImageClick =
                e?.target?.id?.includes("ThreeSixty") ?? false
              !threeSixtyImageClick && zoomInButtonClickAction()
            },
            false
          )
        }

        iframeContainer?.current
          ?.querySelector(".s7button.s7zoomoutbutton")
          ?.addEventListener(
            "click",
            e => {
              const threeSixtyImageClick =
                e?.target?.id?.includes("ThreeSixty") ?? false
              !threeSixtyImageClick && zoomOutButtonClickAction()
            },
            false
          )

        iframeContainer?.current
          ?.querySelector(".s7button.s7zoomresetbutton")
          ?.addEventListener("click", zoomResetButtonClickAction, false)

        // Add fullscreen click
        iframeContainer?.current
          .querySelector(".s7button.s7fullscreenbutton")
          ?.addEventListener(
            "click",
            zoom360CarasoulFullScreenClickAction,
            false
          )

        zoomImageClick = iframeContainer?.current.querySelector(".s7zoomview")

        if (zoomImageClick) {
          if (viewportWidth <= largeIpadSize) {
            zoomImageClick.addEventListener(
              "touchstart",
              ev => {
                setTimeout(function () {
                  zoomImageIconAction()
                }, 1000)
              },
              false
            )
          }
        }

        if (zoomImageClick) {
          const delta = 6
          let startX
          let startY

          zoomImageClick.addEventListener("mousedown", function (event) {
            startX = event.pageX
            startY = event.pageY
            isZoomClick = true
          })

          zoomImageClick.addEventListener("mouseup", function (event) {
            const diffX = Math.abs(event.pageX - startX)
            const diffY = Math.abs(event.pageY - startY)
            isZoomClick = true
            if (diffX < delta && diffY < delta) {
              isZoomClick = false
            }
          })
          zoomImageClick.addEventListener("click", zoomImageClickAction, false)
        }
      }, 500)

      const silckSliderNext =
        iframeContainer?.current.querySelector(".slick-next")
      if (silckSliderNext) {
        silckSliderNext.addEventListener("click", e => {
          e.preventDefault()
          addAnalyticsZoomImageSliderArrow({
            pdpType,
            zoomEntryPoint,
            arrowLable: "right",
            currentImageData,
            totalImages: pdpImageArrayLength,
            productInfo,
            resourceType:
              checkImageResoruceType(currentImageData?.assetId) || null,
          })
        })
      }

      const silckSliderPrev =
        iframeContainer?.current.querySelector(".slick-prev")
      if (silckSliderPrev) {
        silckSliderPrev.addEventListener("click", e => {
          e.preventDefault()
          addAnalyticsZoomImageSliderArrow({
            pdpType,
            zoomEntryPoint,
            arrowLable: "left",
            currentImageData,
            totalImages: pdpImageArrayLength,
            productInfo,
            resourceType:
              checkImageResoruceType(currentImageData?.assetId) || "",
          })
        })
      }
    }
    return () => {
      if (zoomGallaryAddEventListner) {
        clearTimeout(zoomGallaryAddEventListner)
        zoomGallaryRemoveEventListner()
      }
    }
  }, [iframeContainer, zoomEntryPoint, activeImage])

  const zoomGallaryRemoveEventListner = () => {
    iframeContainer?.current
      ?.querySelector(".s7zoomview")
      ?.removeEventListener("click", zoomImageClickAction, false)

    iframeContainer?.current
      ?.querySelector(".s7button.s7zoominbutton")
      ?.removeEventListener(
        "click",
        e => {
          const threeSixtyImageClick =
            e?.target?.id?.includes("ThreeSixty") ?? false
          !threeSixtyImageClick && zoomInButtonClickAction()
        },
        false
      )

    iframeContainer?.current
      ?.querySelector(".s7button.s7zoomoutbutton")
      ?.removeEventListener(
        "click",
        e => {
          const threeSixtyImageClick =
            e?.target?.id?.includes("ThreeSixty") ?? false
          !threeSixtyImageClick && zoomOutButtonClickAction()
        },
        false
      )

    iframeContainer?.current
      ?.querySelector(".s7button.s7zoomresetbutton")
      ?.removeEventListener("click", zoomResetButtonClickAction, false)

    // Remove fullscreen click
    iframeContainer?.current
      .querySelector(".s7button.s7fullscreenbutton")
      ?.removeEventListener(
        "click",
        zoom360CarasoulFullScreenClickAction,
        false
      )
  }

  // 360 zoom icon code start
  useEffect(() => {
    let threeSixtyAddEventListners
    if (currentSlide === 1 && threeSixtyIframeContainer?.current) {
      threeSixtyAddEventListners = setTimeout(() => {
        // Add fullscreen click
        threeSixtyIframeContainer?.current
          .querySelector(".s7button.s7fullscreenbutton")
          ?.addEventListener("click", zoom360FullScreenClickAction, false)

        threeSixtyIframeContainer?.current
          .querySelector("#s7viewerGallery")
          ?.addEventListener("click", zoomInButton360full, false)
      }, 500)
    }
    return () => {
      if (threeSixtyAddEventListners) {
        clearTimeout(threeSixtyAddEventListners)
        threeSixtyRemoveEventListners()
        setIsThreeSixtyRender(false)
      }
    }
  }, [currentSlide, isThreeSixtyRender])
  const threeSixtyRemoveEventListners = () => {
    // Remove fullscreen click
    threeSixtyIframeContainer?.current
      .querySelector(".s7button.s7fullscreenbutton")
      ?.removeEventListener("click", zoom360FullScreenClickAction, false)
    threeSixtyIframeContainer?.current
      .querySelector("#s7viewerGallery")
      ?.removeEventListener("click", zoomInButton360full, false)
    clearTimeout(fullScreenTimer)
    clearTimeout(fullScreenTabTimer)
  }

  let counterThreeSixty = 0
  let counterThreeSixtyZoomOut = 0

  const zoomInButton360ClickAction = ({
    is360Image = false,
    isImageGallery = false,
  }) => {
    const currentImageData = {
      assetId: resourceName?.[0],
      label: resourceAltText?.[0],
      index: 1,
    }
    counterThreeSixty++
    addAnalyticsClickZoomImage({
      pdpType,
      zoomEntryPoint: isImageGallery ? "image gallery" : "image reel",
      zoomAction: "zoom in",
      currentImageData,
      totalImages: pdpCustomImagesArray?.length,
      counterThreeSixty,
      resourceType: resourceTypeImg?.[0].toLowerCase(),
      is360Image,
      productInfo,
    })
  }

  const zoomOut360ButtonClickAction = ({
    is360Image = false,
    isImageGallery = false,
  }) => {
    const currentImageData = {
      assetId: resourceName?.[0],
      label: resourceAltText?.[0],
      index: 1,
    }
    counterThreeSixtyZoomOut++
    addAnalyticsClickZoomImage({
      pdpType,
      zoomEntryPoint: isImageGallery ? "image gallery" : "image reel",
      zoomAction: "zoom out",
      currentImageData,
      totalImages: pdpCustomImagesArray?.length,
      counter: counterThreeSixtyZoomOut,
      resourceType: resourceTypeImg?.[0].toLowerCase(),
      is360Image,
      productInfo,
    })
  }

  const zoom360CarasoulSpinnerClickAction = () => {
    zoom360SpinnerClickAction(false, true)
  }

  const zoom360SpinnerClickAction = (
    is360Image = true,
    threeSixtyImageClick = false,
    spinType = ""
  ) => {
    setTabIndexGallery()
    const currentImageData = {
      assetId: resourceName?.[0],
      label: resourceAltText?.[0],
      index: 1,
    }
    addAnalyticsClickZoomSpinnerAndFullscreen({
      pdpType,
      zoomEntryPoint,
      currentImageData,
      totalImages: pdpCustomImagesArray?.length,
      resourceType: resourceTypeImg?.[0].toLowerCase(),
      is360Image,
      buttonType: "spin interaction",
      threeSixtyImageClick,
      spinType,
      productInfo,
    })
  }

  const zoom360CarasoulFullScreenClickAction = () => {
    zoom360FullScreenClickAction(false, true)
  }

  const zoomInButton360full = () => {
    if (viewportWidth <= largeIpadSize) {
      const threeSixtyData =
        threeSixtyIframeContainer?.current.querySelector(".s7container")

      const zoomCursorType = threeSixtyData?.getAttribute("mode")
      if (zoomCursorType === "fullscreen") {
        document.body.style.overflow = ""
      }
    }
  }
  const zoom360FullScreenClickAction = (
    is360Image = true,
    threeSixtyImageClick = false
  ) => {
    setTabIndexGallery()
    if (viewportWidth <= largeIpadSize) {
      fullScreenTimer = setTimeout(function () {
        const threeSixtyData =
          threeSixtyIframeContainer?.current.querySelector(".s7container")
        if (threeSixtyData) {
          threeSixtyData?.addEventListener("click", zoomInButton360full, false)
        }
        const zoomCursorType = threeSixtyData?.getAttribute("mode")
        if (zoomCursorType === "fullscreen") {
          document.body.classList.add("full-screen-open")
          window.scrollTo({ top: 0, behavior: "smooth" })
        } else {
          document.body.style.overflow = ""
          document.body.classList.remove("full-screen-open")

          document.getElementById("s7viewerGallery").innerHTML = ""
          if (resourceName?.[0]) {
            spin360PdpGallery(resourceName?.[0], zoomSpinCBPdp)
            setIsThreeSixtyRender(true)
          }
        }
      }, 100)
    }

    const currentImageData = {
      assetId: resourceName?.[0],
      label: resourceAltText?.[0],
      index: 1,
    }

    const screenTypeGallary = threeSixtyIframeContainer?.current
      .querySelector(".s7container")
      ?.getAttribute("mode")
    const screenTypeMain = iframeContainer?.current
      .querySelector(".s7container")
      ?.getAttribute("mode")

    let screenType = ""

    if (!is360Image) {
      screenType = screenTypeMain === "normal" ? "full screen" : "minimise"
    } else {
      screenType = screenTypeGallary === "normal" ? "full screen" : "minimise"
    }

    addAnalyticsClickZoomSpinnerAndFullscreen({
      pdpType,
      zoomEntryPoint,
      currentImageData,
      totalImages: pdpCustomImagesArray?.length,
      resourceType: resourceTypeImg?.[0].toLowerCase(),
      is360Image,
      threeSixtyImageClick,
      screenType,
      productInfo,
    })
  }
  // 360 zoom icon code end

  let counter = 0
  let zoomOutCounter = 0
  let fullScreenTabTimer
  const zoomImageClickAction = useCallback(e => {
    const zoomImageClick = iframeContainer?.current.querySelector(".s7zoomview")
    const cursortype = zoomImageClick?.getAttribute("cursortype")

    if (viewportWidth <= largeIpadSize) {
      isZoomClick = false
    }
    setTimeout(function () {
      setTabIndexGallery()
    }, 1000)
    if (!isZoomClick) {
      setTimeout(function () {
        setTabIndexGallery()
        checkImageResoruceType(currentImageData?.assetId)
        if (cursortype !== "reset" || cursortype !== "drag") {
          setTabIndexGallery()

          if (cursortype === "zoomin") {
            counter++
            addAnalyticsClickZoomImage({
              pdpType,
              zoomEntryPoint,
              zoomAction: "zoom in",
              currentImageData,
              totalImages: pdpImageArrayLength,
              counter,
              resourceType: checkImageResoruceType(currentImageData?.assetId),
              is360Image: false,
              productInfo,
            })
          } else {
            zoomOutCounter++
            addAnalyticsClickZoomImage({
              pdpType,
              zoomEntryPoint,
              zoomAction: "zoom out",
              currentImageData,
              totalImages: pdpImageArrayLength,
              counter: zoomOutCounter,
              resourceType: checkImageResoruceType(currentImageData?.assetId),
              is360Image: false,
              productInfo,
            })
          }
        }
      }, 50)
    }
  })

  const zoomInButtonClickAction = useCallback(() => {
    const threeSixtyImageClick = false
    if (viewportWidth <= largeIpadSize) {
      setTimeout(function () {
        const zoomInImageClick = iframeContainer?.current.querySelector(
          ".s7button.s7zoominbutton"
        )
        const zoomImageOutClick = iframeContainer?.current.querySelector(
          "#s7viewer_zoomOutButton"
        )
        const zoomCursorType = zoomInImageClick.getAttribute("state")
        if (!threeSixtyImageClick) {
          if (zoomCursorType === "disabled") {
            zoomInImageClick.setAttribute("style", "display: none !important")
            zoomImageOutClick.setAttribute("style", "display: block !important")
          } else {
            zoomInImageClick.setAttribute("style", "display: block !important")
            zoomImageOutClick.setAttribute("style", "display: none !important")
          }
        }
      }, 1000)
    }

    counter++
    !threeSixtyImageClick &&
      addAnalyticsClickZoomImage({
        pdpType,
        zoomEntryPoint,
        zoomAction: "zoom in",
        currentImageData,
        totalImages: pdpImageArrayLength,
        counter,
        resourceType: checkImageResoruceType(currentImageData?.assetId),
        is360Image: false,
        threeSixtyImageClick,
        productInfo,
      })
    setTabIndexGallery()
  })

  const zoomOutButtonClickAction = useCallback(() => {
    zoomOutCounter++
    const threeSixtyImageClick = false
    !threeSixtyImageClick &&
      addAnalyticsClickZoomImage({
        pdpType,
        zoomEntryPoint,
        zoomAction: "zoom out",
        currentImageData,
        totalImages: pdpImageArrayLength,
        counter: zoomOutCounter,
        resourceType: checkImageResoruceType(currentImageData?.assetId),
        is360Image: false,
        threeSixtyImageClick,
        productInfo,
      })
    if (viewportWidth <= largeIpadSize) {
      setTimeout(function () {
        const zoomInImageClick = iframeContainer?.current.querySelector(
          ".s7button.s7zoominbutton"
        )
        const zoomImageOutClick = iframeContainer?.current.querySelector(
          "#s7viewer_zoomOutButton"
        )
        if (!threeSixtyImageClick) {
          const zoomCursorType = zoomImageOutClick.getAttribute("state")
          if (zoomCursorType === "disabled") {
            zoomInImageClick.setAttribute("style", "display: block !important")
            zoomImageOutClick.setAttribute("style", "display: none !important")
          } else {
            zoomInImageClick.setAttribute("style", "display: none !important")
            zoomImageOutClick.setAttribute("style", "display: block !important")
          }
        }
      }, 1000)
    }
  })

  const zoomResetButtonClickAction = useCallback(e => {
    counter = 0
    zoomOutCounter = 0
    const threeSixtyImageClick = e?.target?.id?.includes("ThreeSixty") ?? false
    !threeSixtyImageClick &&
      addAnalyticsClickZoomReset({
        pdpType,
        zoomEntryPoint,
        currentImageData,
        totalImages: pdpImageArrayLength,
        resourceType: checkImageResoruceType(currentImageData?.assetId),
        is360Image: false,
        threeSixtyImageClick,
        productInfo,
      })
  })

  const lastTabIndex = 0
  let currentIndex = 90

  const handleKey = () => {
    window.addEventListener(
      "focusin",
      function () {
        currentIndex = document.activeElement.tabIndex
      },
      true
    )

    let curIndex = currentIndex
    if (curIndex === lastTabIndex) {
      curIndex = 90
    }
    const tabbables = document.querySelectorAll(".image-overlay")

    for (let i = 0; i < tabbables.length; i++) {
      if (tabbables[i].tabIndex === curIndex) {
        tabbables[i].focus()
        break
      }
    }
  }

  const setTabIndexGallery = () => {
    fullScreenTabTimer = setTimeout(function () {
      const zoomInButtonClick = iframeContainer?.current.querySelector(
        ".s7button.s7zoominbutton"
      )
      const zoomOutButtonClick = iframeContainer?.current.querySelector(
        ".s7button.s7zoomoutbutton"
      )
      const zoomResetButton = iframeContainer?.current.querySelector(
        ".s7button.s7zoomresetbutton"
      )
      const zoomLeftArrow =
        iframeContainer?.current.querySelector(".s7panleftbutton")
      const zoomRightArrow =
        iframeContainer?.current.querySelector(".s7panrightbutton")
      const zooms7fullscreenbutton = iframeContainer?.current.querySelector(
        ".s7fullscreenbutton"
      )
      if (zoomInButtonClick) {
        zoomInButtonClick.setAttribute("tabindex", "96")
        zoomOutButtonClick.setAttribute("tabindex", "97")
        zoomResetButton.setAttribute("tabindex", "98")
      }
      if (zoomLeftArrow || zoomRightArrow) {
        zoomLeftArrow.setAttribute("tabindex", "98")
        zoomRightArrow.setAttribute("tabindex", "98")
      }
      if (zooms7fullscreenbutton) {
        zooms7fullscreenbutton.setAttribute("tabindex", "98")
      }
    }, 100)
  }

  const zoomImageIconAction = () => {
    const zoomInImageClick = iframeContainer?.current.querySelector(
      ".s7button.s7zoominbutton"
    )
    const zoomImageOutClick = iframeContainer?.current.querySelector(
      "#s7viewer_zoomOutButton"
    )
    const zoomCursorType = zoomInImageClick.getAttribute("state")
    if (zoomCursorType === "disabled") {
      zoomOutCounter++
      addAnalyticsClickZoomImage({
        pdpType,
        zoomEntryPoint,
        zoomAction: "zoom out",
        currentImageData,
        totalImages: pdpImageArrayLength,
        counter: zoomOutCounter,
        resourceType: checkImageResoruceType(currentImageData?.assetId),
        is360Image: false,
        productInfo,
      })
      zoomInImageClick.setAttribute("style", "display: none !important")
      zoomImageOutClick.setAttribute("style", "display: block !important")
    } else {
      counter++
      addAnalyticsClickZoomImage({
        pdpType,
        zoomEntryPoint,
        zoomAction: "zoom in",
        currentImageData,
        totalImages: pdpImageArrayLength,
        counter,
        resourceType: checkImageResoruceType(currentImageData?.assetId),
        is360Image: false,
        productInfo,
      })

      zoomInImageClick.setAttribute("style", "display: block !important")
      zoomImageOutClick.setAttribute("style", "display: none !important")
    }
  }

  const checkImageResoruceType = (assetId = "") => {
    if (productImagesWithUrls?.length > 0) {
      return productImagesWithUrls
        .filter(img => {
          return img.includes(assetId)
        })
        ?.toString()
        ?.split("|")?.[2]
    }
  }
  const pdpThumbnailAnyltics = (element, i = 0) => {
    setActiveIndex(i)
    setThumbnailClicked(true)
    if (element?.assetId || element?.resourceName?.[0]) {
      const resourceType = element?.resourceName?.[0]
        ? element?.resourceTypeImg?.[0]
        : checkImageResoruceType(element?.assetId)
      addPdpThumbnailAnylticsClick({
        pdpImageInfo: element,
        totalImages: pdpImageArrayLength,
        pdpType,
        currentIndex: i + 1,
        resourceType: resourceType?.toLowerCase(),
        productInfo,
      })
    }
  }
  const render360Image = () => {
    return (
      <div
        className="pdp-image-reel__image-display"
        key={`gallery-zoom-image-360-product`}
      >
        <div id="s7viewerGallery"></div>
      </div>
    )
  }
  useEffect(() => {
    const timerSpin360PdpGallery = setTimeout(() => {
      if (resourceName) {
        spin360PdpGallery(resourceName?.[0])
      }
    }, 100)
    return () => {
      clearTimeout(timerSpin360PdpGallery)
    }
  }, [resourceName])

  const renderTotalImages = () =>
    data && pdpCustomImagesArray && totalImages ? (
      pdpCustomImagesArray?.map((element, i) => {
        const isVideo = element.type === "video"
        const layerImageResourse = element?.layerUrl || ""
        const resourceImageName = element?.resourceName?.[0]
        const resourceImgFullWebUrl = element?.resourceFullWebUrl?.[0]
        return (
          <SwiperSlide
            elementid={element.assetId}
            id={i}
            key={`gallery-zoom-image-${i}`}
            className={`pdp-image-reel__image-list ${
              resourceImageName && resourceImgFullWebUrl
                ? "noSwiping swiper-no-swiping"
                : ""
            }  `}
            role="listitem"
            aria-label={element?.label}
            onClick={() =>
              !isVideo
                ? openImageZoom(
                    element.assetId,
                    i,
                    element?.label,
                    element,
                    layerImageResourse
                  )
                : imageZoomMobileVideoClick(element.url, i)
            }
          >
            {resourceImageName && resourceImgFullWebUrl
              ? render360Image()
              : null}
            {!element.type && !resourceImageName && !resourceImgFullWebUrl ? (
              <div
                className="pdp-image-reel__image-display"
                key={`gallery-zoom-image-${element.assetId}`}
              >
                <img
                  onError={e => (e.target.src = missingImage?.src)}
                  src={
                    layerImageResourse
                      ? layerImageResourse
                      : getMainImageSrc(element.assetId)
                  }
                  alt={element.label}
                  tabIndex="0"
                  className={`${i === 0 ? "print" : "no-print"}`}
                />
                <img
                  src={tapImageZoom?.src}
                  alt={element.label}
                  tabIndex="0"
                  className="tap-image-zoom"
                />
              </div>
            ) : !resourceImgFullWebUrl && !resourceImageName ? (
              <div
                className="pdp-video-wrapper"
                key={`gallery-zoom-image-${element.url}`}
                id="pdpVideos"
              >
                <div id="pdp-video">
                  {viewportWidth < 971 ? (
                    <VideoWrapper
                      thumb
                      alt={element.label}
                      videoId={element.url}
                      imageSequence={imageSequence}
                      playThumb={viewportWidth < largeIpadSize && !isModel}
                      width="100%"
                      height="350"
                      getVideoInfo={getVideoInfo}
                      zoomEntryPoint={zoomEntryPoint}
                    />
                  ) : (
                    <VideoWrapper
                      videoId={element.url}
                      width="100%"
                      height="350"
                      index={i + 1}
                      totalPdpImages={pdpImageArrayLength}
                      anyliticsText="main"
                      zoomEntryPoint={zoomEntryPoint}
                    />
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
          </SwiperSlide>
        )
      })
    ) : (
      <li
        className="pdp-image-reel__image-list"
        onClick={() => openImageZoom(initialImgUrl)}
      >
        <div className="pdp-image-reel__image-display">
          {initialImgUrl && pdpDesktopImage ? (
            <img
              src={pdpDesktopImage.replace("/}", `/${initialImgUrl}}`)}
              alt={initialImgAlt}
              tabIndex="0"
              className="print"
            />
          ) : (
            <p className="shimmer-loading__para shimmer height-400" />
          )}
        </div>
      </li>
    )

  return (
    <>
      <ImageHeroSection
        data={data}
        pdpCustomImagesArray={pdpCustomImagesArray}
        zoomVideoId={zoomVideoId}
        closeZoomImageClick={closeZoomImageClick}
        iframeContainer={iframeContainer}
        currentVideoId={currentVideoId}
        zoomEntryPoint={zoomEntryPoint}
        getVideoInfo={getVideoInfo}
        width={viewportWidth}
        activeImage={activeImage}
        slickRef={slickRef}
        threeSixtyZoomClick={threeSixtyZoomClick}
        threeSixtyOpen={threeSixtyOpen}
        productInfo={productInfo}
        assetAccountName={assetAccountName}
        appendPresetToUrl={appendPresetToUrl}
        swatchUrl={swatchUrl}
        presetConfigObject={presetConfigObject}
        imageZoomClick={imageZoomClick}
        zoomVideoIcon={zoomVideoIcon}
        pdpDesktopImage={pdpDesktopImage}
        imageZoomVideoClick={imageZoomVideoClick}
        {...props}
      />

      <div
        className={`pdp-image-reel ${
          pdpImageArrayLength && pdpImageArrayLength <= 1
            ? "full-image-pdp "
            : ""
        } `}
      >
        <div
          className={`pdp-thumbnail-vertical ${
            pdpImageArrayLength && pdpImageArrayLength <= 1
              ? "hide-slider "
              : ""
          }`}
        >
          <Swiper
            key="slider-pdp-thumbnail"
            onSlideChange={swiper => beforeChangeHandlerFilmStrip(swiper)}
            direction={
              viewportWidth >= largeIpadSize ? "vertical" : "horizontal"
            }
            slideToClickedSlide={true}
            focusableElements={true}
            slidesPerView={viewportWidth >= largeIpadSize ? 6 : "auto"}
            spaceBetween="15px"
            freeMode={true}
            watchSlidesProgress={true}
            className="slider-pdp-thumbnail"
            onSwiper={setThumbsSwiper}
            keyboard={true}
            mousewheel={true}
            modules={[Navigation, Keyboard, A11y, FreeMode]}
            a11y={{ enabled: true }}
            ref={swiperThumbRef}
            scrollbar={viewportWidth >= 1024 ? false : { draggable: true }}
            roundLengths={true}
            shouldSwiperUpdate={true}
          >
            {data && pdpCustomImagesArray && pdpImageArrayLength ? (
              pdpCustomImagesArray.map((element, i) => {
                const resourcePdpImageName = element?.resourceName?.[0] || ""

                const layerImageResourse = element?.layerUrl
                const resourcePdpImageUrl =
                  element?.resourceFullWebUrl?.[0] || ""
                const resourcePdpImageAlt = element?.resourceAltText?.[0] || ""
                return (
                  <React.Fragment key={`gallery-zoom-image-${i}`}>
                    {!element.type ? (
                      <SwiperSlide
                        virtualIndex={i}
                        className={`image-wrapper ${
                          activeIndex === i ? "imageActiveThumb" : ""
                        } ${
                          resourcePdpImageUrl && resourcePdpImageName
                            ? "overlay-image-360"
                            : ""
                        }`}
                        key={`zoom-image-${element?.assetId}`}
                        onClick={() => pdpThumbnailAnyltics(element, i)}
                      >
                        {resourcePdpImageUrl && resourcePdpImageName ? (
                          <>
                            <Image
                              role="img"
                              src={resourcePdpImageUrl}
                              alt={resourcePdpImageAlt}
                              width={60}
                              height={60}
                              tabIndex="0"
                            />
                            <span className="zoom-video-icon">
                              <img
                                src={threeSixtyIcon?.src}
                                alt="pdp-image"
                                tabIndex={`10 ${+i}`}
                              />
                            </span>
                          </>
                        ) : (
                          <img
                            src={
                              layerImageResourse
                                ? layerImageResourse
                                : getThumbnailSrc(element.assetId)
                            }
                            alt={element?.label}
                            width={60}
                            height={60}
                            loading="eager"
                            decoding="async"
                            onError={e =>
                              (e.currentTarget.src = missingImage?.src)
                            }
                          />
                        )}
                      </SwiperSlide>
                    ) : (
                      <SwiperSlide
                        key={`zoom-video-${i}`}
                        onClick={() => imageZoomVideoClick(element.url, i)}
                        className={`image-wrapper zoom-video-section${
                          activeIndex === i ? " imageActiveThumb" : ""
                        } `}
                      >
                        <VideoWrapper
                          thumb
                          videoId={element.url}
                          getVideoInfo={getVideoInfo}
                          index={i}
                          tabIndex="0"
                          totalPdpImages={pdpImageArrayLength}
                          zoomEntryPoint={zoomEntryPoint}
                        />
                        <span className="zoom-video-icon">
                          <img src={pdpVideoPlayIcon?.src} alt="pdp video" />
                        </span>
                      </SwiperSlide>
                    )}
                  </React.Fragment>
                )
              })
            ) : (
              <SwiperSlide className="image-wrapper ">
                {initialImgUrl && pdpDesktopImage ? (
                  <img
                    role="button"
                    src={pdpDesktopImage.replace("/}", `/${initialImgUrl}}`)}
                    alt={initialImgAlt}
                  />
                ) : (
                  <p className="shimmer-loading__para shimmer height-400" />
                )}
              </SwiperSlide>
            )}
          </Swiper>

          {pdpImageArrayLength && pdpImageArrayLength > 6 ? (
            <div className="image-gallery-view">
              <p
                className="gallery-image-number"
                tabIndex="0"
                onClick={() =>
                  viewGalleryImageClick(
                    layerImageData?.layerUrl || firstImageForZoom
                  )
                }
              >
                +{pdpImageArrayLength - 6}
              </p>
            </div>
          ) : null}
        </div>

        <div
          className={`pdp-image-reel__image-stack-view  ${
            pdpImageArrayLength && pdpImageArrayLength <= 1
              ? "full-image-width "
              : ""
          }${
            viewportWidth < largeIpadSize
              ? " pdp-image-reel__slider-container"
              : ""
          }`}
        >
          <ul
            className={`pl-0 list-inline pdp-image-reel__image-stack-list ${
              resourceName?.[0] && resourceFullWebUrl?.[0]
                ? "three-sixty-image-pdp-gallery"
                : ""
            }`}
            id={galleryStackId}
            ref={threeSixtyIframeContainer}
          >
            <Swiper
              key="pdpSliderKey"
              modules={[Navigation, Keyboard, A11y]}
              navigation
              slidesPerView={1}
              onSlideChange={swiper => beforeChangeHandler(swiper)}
              thumbs={{ swiper: thumbsSwiper }}
              focusableElements={false}
              keyboard={true}
              className="slider-pdp"
              a11y={{ enabled: true }}
              ref={swiperPdpRef}
            >
              {!initialImgUrl && !pdpDesktopImage ? (
                <p className="shimmer-loading__para shimmer height-400" />
              ) : (
                renderTotalImages()
              )}
            </Swiper>
          </ul>
        </div>
      </div>
      {resourceCredits ? (
        <p className="pdp-image-reel__photo-credit">{resourceCredits}</p>
      ) : null}
    </>
  )
}

ImageReel.propTypes = {
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  staticTexts: PropTypes.object,
  productInfo: PropTypes.array,
  imageClickCounter: PropTypes.number,
  threeSixtyResourceData: PropTypes.object,
}

export default ImageReel
